function importAll(r) {
    return r.keys().map(r);
}

const equipmentImages = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentText = [{name: `Medium nonstick pan`}, {name: `Medium pot`},]

export const equipment = equipmentText.map((item, index) => {
    return {
        name: item.name,
        note: item.note, 
        img: equipmentImages[index]
    }
})